import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Flex, Loader, MultiSelect, Stack, Text } from "@mantine/core";
import { useForm } from "@mantine/form";
import { AppModal } from "../../shared/AppModal";
import { Check } from "@mui/icons-material";
import { useEffect } from "react";
import { useAssignProvidersToPatientMutation, useGetPatientAndProvidersQuery } from "../../graphql/graphql";
import { ImageWithPlaceholder } from "../../shared/ImageWithPlaceholder";
import { showErrorNotification, showSuccessNotification } from "../../shared/Notifications";
export const ManageProvidersForPatientModal = ({ patientId, opened, close }) => {
    // Mutations
    const [{ fetching: assignFetching }, assignProvidersToPatient] = useAssignProvidersToPatientMutation();
    //Queries
    const [{ data, fetching }] = useGetPatientAndProvidersQuery({
        variables: {
            patientId: patientId ?? ""
        },
        pause: !opened || !patientId
    });
    const patient = data?.patients?.patient;
    const patientProviderIds = (patient?.providers ?? [])
        .map((provider) => provider.userId)
        .filter((pId) => !!pId);
    const organizationProviders = data?.users?.users ?? [];
    const organizationProvidersList = organizationProviders
        .map((provider) => ({
        value: provider.userId,
        label: `${provider.firstName} ${provider.lastName}`
    }))
        .filter((provider) => provider !== null);
    // Form
    const form = useForm({
        initialValues: {
            providerIds: patientProviderIds ?? []
        }
    });
    // Effects
    useEffect(() => {
        if (patientProviderIds.length > 0) {
            form.setFieldValue("providerIds", patientProviderIds);
        }
    }, [data]);
    // Handlers
    const handleSubmit = async (event) => {
        event.preventDefault();
        const valid = form.validate();
        if (valid.hasErrors)
            return;
        const formValues = form.getValues();
        await assignProvidersToPatient({
            input: {
                patientId: patientId ?? "",
                providerIds: (formValues.providerIds ?? []).filter((id) => id != null)
            }
        })
            .catch((error) => {
            console.error(error);
            showErrorNotification();
        })
            .then(() => {
            showSuccessNotification("Providers assigned successfully");
            close();
        });
    };
    return (_jsx(AppModal, { title: `Manage Providers for ${patient?.firstName} ${patient?.lastName}`, opened: opened, onClose: close, children: _jsxs(Stack, { gap: "md", children: [_jsx(MultiSelect, { data: organizationProvidersList, label: "Providers", placeholder: "Select Providers", rightSection: fetching ? _jsx(Loader, { size: "xs" }) : null, searchable: true, clearable: true, renderOption: (option) => {
                        const imageUrl = organizationProviders.find((provider) => provider.userId === option.option.value)?.imageUrl;
                        return (_jsxs(Flex, { align: "center", gap: "xs", children: [form.values.providerIds?.includes(option.option.value) && (_jsx(Check, { style: {
                                        fontSize: "1rem",
                                        color: "var(--mantine-color-gray-5)"
                                    } })), _jsx(ImageWithPlaceholder, { imageUrl: imageUrl, avatarText: option.option.label, size: 24 }), _jsx(Text, { variant: "body", children: option.option.label })] }));
                    }, ...form.getInputProps("providerIds") }), _jsx(Flex, { justify: "flex-end", children: _jsx(Button, { variant: "filled", loading: assignFetching, onClick: handleSubmit, children: "Assign Providers" }) })] }) }));
};
